 
import { Link } from "react-router-dom"
import nikeLogo from "../assets/logo.png" 
import { showCart } from "../ReduxToolKit/cartSlice";
import { useDispatch, useSelector } from "react-redux";
const NavBar = ()=>{ 
    const dispatch = useDispatch(); 
    const {  cartTotalQty } = useSelector(state => state.Cart);
    return(
        <>
        <nav className="flex justify-between items-center py-4">
            <Link to="/" className="">
                <img className="w-[80px] md:w-[100px]" src={nikeLogo} alt="nike-logo" />
            </Link>
            <ul className="flex gap-2 items-center">
                <li className="cursor-pointer"><i className="text-lg fas fa-search"></i></li>
                <li className="cursor-pointer"><i className="text-lg fas fa-heart"></i></li>
                <li className="relative cursor-pointer" onClick={()=>dispatch(showCart(true))}>
                    <i className="text-lg fas fa-shopping-bag"></i>
                    <span className="cartItems">{cartTotalQty}</span>
                </li>
            </ul>
        </nav>
        </>
    )
}
export default NavBar